import { useEffect, useState } from 'react';

export function useModalPage({ onOpen }: { onOpen?: () => void } = {}) {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    setIsOpen(true);
    onOpen?.();
  }, []);

  return {
    isOpen,
    setIsOpen,
  };
}
